export default function getScrollParent(node: Element) {
    const regex = /(auto|scroll)/;

    const parents = (_node: Node, ps: Node[]): Node[] => {
        if (_node.parentNode === null) {
            return ps;
        }
        return parents(_node.parentNode, ps.concat([_node]));
    };

    const style = (_node: Element, prop: string):string => {
        return getComputedStyle(_node, null).getPropertyValue(prop);
    }
    const overflow = (_node: Element):string => {
        return style(_node, 'overflow') + style(_node, 'overflow-y') + style(_node, 'overflow-x');
    }

    const scroll = (_node: HTMLElement):boolean => {
        return regex.test(overflow(_node));
    }

    /* eslint-disable consistent-return */
    const scrollParent = (_node: Element) => {
        if (!(_node instanceof HTMLElement || _node instanceof SVGElement)) {
            return;
        }

        const ps = parents(_node.parentNode as Element, []);

        for (let i = 0; i < ps.length; i += 1) {
            if (scroll(ps[i] as HTMLElement)) {
                return ps[i];
            }
        }

        return document.scrollingElement || document.documentElement;
    };

    return scrollParent(node);
};